import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { riskLevelFromRisk } from 'src/models/risk.js';
import { classMap } from 'lit/directives/class-map.js';
import { t } from 'src/i18n';

@customElement('d-view-risk-simple')
export class DViewRiskSimple extends LitElement {
  static readonly styles = [
    css`
      :host {
        display: block;
      }
      div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 36px;
        border-radius: 18px;
        background-color: hsla(0, 0%, 0%, 0.1);
        color: var(--text-color);
        font-size: 16px;
        font-weight: 500;
        line-height: 100%;
      }
      .low {
        background-color: var(--risk-color-1);
        color: white;
      }
      .medium {
        background-color: var(--risk-color-2);
        color: white;
      }
      .high {
        background-color: var(--risk-color-3);
        color: white;
      }
      .very-high {
        background-color: var(--risk-color-4);
        color: white;
      }
    `,
  ];
  @property({ type: Number })
  value = 0;

  private get riskLevel(): number | undefined {
    return riskLevelFromRisk(this.value);
  }

  private get riskClass() {
    return {
      low: this.riskLevel === 1,
      medium: this.riskLevel === 2,
      high: this.riskLevel === 3,
      'very-high': this.riskLevel === 4,
    };
  }

  private get riskLabel() {
    if (this.riskLevel === 1) {
      return t('computers.riskLow');
    }
    if (this.riskLevel === 2) {
      return t('computers.riskModerate');
    }
    if (this.riskLevel === 3) {
      return t('computers.riskHigh');
    }
    if (this.riskLevel === 4) {
      return t('computers.riskVeryHigh');
    }
    return t('riskAssessments.riskLabelNotAssessed');
  }

  render() {
    return html` <div class=${classMap(this.riskClass)}>${this.riskLabel}</div> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-view-risk-simple': DViewRiskSimple;
  }
}
